import React from 'react';

import { useCustomValuesOut } from '@helpers/hooks/pages/dashboard/customValues/useCustomValuesOut';
import Header from './Header';
import Body from './Body';

import * as S from './styles';

const NewCustomValueSidemodal: React.FC = () => {
  const { isNewCustomValueSidemodalOpen, handleNewCustomValueSidemodalOpen } = useCustomValuesOut();

  return (
    <S.SideModal isOpen={isNewCustomValueSidemodalOpen} toggle={handleNewCustomValueSidemodalOpen}>
      <Header />
      <Body />
    </S.SideModal>
  );
};

export default NewCustomValueSidemodal;
